module.exports = __webpack_public_path__ + "img/01.e86746e6.png";